import { LinearProgress } from '../LinearProgress/LinearProgress';

interface StepProgressProps {
  numSteps: number;
  step: number;
}

export const StepProgress: React.FC<StepProgressProps> = ({ numSteps, step }) => {
  const completionPercentage = (step / numSteps) * 100;
  return <LinearProgress value={completionPercentage} />;
};
